import { render, staticRenderFns } from "./funes_pres_M.vue?vue&type=template&id=7b4b46ac"
import script from "./funes_pres_M.vue?vue&type=script&lang=js"
export * from "./funes_pres_M.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports